<!-- ── CASHFLOW STEP 4 — Costs & Expenses ── -->
<app-ip-shell [activeStep]="4" [steps]="cfSteps" calculatorName="Cash Flow Calculator">

  <!-- ── FORM COLUMN ── -->
  <div formCol>
    <div class="ip-form-head">
      <div class="ip-form-head__step-meta">Step 04 &middot; Costs &amp; Expenses</div>
      <h1 class="ip-form-head__title">Acquisition &amp; running costs</h1>
      <p class="ip-form-head__subtitle">
        SDLT is calculated automatically based on your buyer status. Configure your management fee and recurring charges to complete the model.
      </p>
    </div>

    <div class="ip-form-body">

      <!-- SDLT Banner -->
      <div class="ip-field">
        <div class="ip-field__head">
          <label class="ip-field__label">Stamp Duty &amp; Land Tax</label>
          <span class="ip-hint"><span class="ip-hint__dot"></span>Auto-calculated · rates as at 2026</span>
        </div>
        <div class="ip-sdlt-callout">
          <div class="ip-sdlt-callout__main">
            <span class="ip-sdlt-callout__title">
              {{ calcData?.BuyerType === 'ftb' ? 'First Time Buyer' : 'Investment / 2nd Property' }}
              &middot;
              {{ foreignbuyer === '1' ? 'Foreign Buyer' : 'UK Resident' }}
            </span>
            <span class="ip-sdlt-callout__sub">
              <ng-container *ngIf="calcData?.BuyerType === 'ftb' && foreignbuyer !== '1'">0% up to £300k · FTB relief rates</ng-container>
              <ng-container *ngIf="calcData?.BuyerType === 'ftb' && foreignbuyer === '1'">FTB relief rates + 2% non-resident surcharge</ng-container>
              <ng-container *ngIf="calcData?.BuyerType !== 'ftb' && foreignbuyer !== '1'">Standard rates + 5% additional dwelling surcharge</ng-container>
              <ng-container *ngIf="calcData?.BuyerType !== 'ftb' && foreignbuyer === '1'">Standard rates + 5% ADS + 2% non-resident surcharge</ng-container>
            </span>
          </div>
          <div class="ip-sdlt-callout__value">£{{ stampDutyLandTax || '0' }}</div>
        </div>
      </div>

      <!-- Upfront costs section -->
      <div class="ip-costs-label">Upfront Costs</div>

      <!-- Loan Origination Fee (mortgage only) -->
      <div class="ip-field" *ngIf="calcData.optmortgage!='0'">
        <div class="ip-field__head">
          <label class="ip-field__label" for="loanOriginationFee">Loan origination fee</label>
          <span class="ip-hint"><span class="ip-hint__dot"></span>% of loan amount</span>
        </div>
        <div class="ip-input">
          <input
            type="text"
            id="loanOriginationFee"
            class="ip-input__field"
            autocomplete="off"
            placeholder="e.g. 1"
            [(ngModel)]="loanOriginationFee"
            (keyup)="loanOriginationFee=validation.appendPercent($event,loanOriginationFee)"
            (keypress)="validation.DesimalOnly($event,loanOriginationFee)">

        </div>
      </div>

      <!-- Annual recurring costs section -->
      <div class="ip-costs-label">Annual Recurring Costs</div>

      <!-- Letting Management Fee -->
      <div class="ip-field">
        <div class="ip-field__head">
          <label class="ip-field__label" for="letteingManagFee">Lettings &amp; Management fees</label>
          <span class="ip-hint"><span class="ip-hint__dot"></span>{{ PropertyLondon == 1 ? 'London avg: 12%' : 'UK avg: 10%' }}</span>
        </div>
        <div class="ip-input">
          <input
            type="text"
            id="letteingManagFee"
            class="ip-input__field"
            autocomplete="off"
            placeholder="{{ PropertyLondon == 1 ? '12' : '10' }}"
            [(ngModel)]="letteingManagFee"
            (keyup)="letteingManagFee=validation.appendPercent($event,letteingManagFee)"
            (keypress)="validation.DesimalOnly($event,letteingManagFee)">
          <span class="ip-input__suffix">of rent</span>
        </div>
      </div>

      <!-- Ground Rent -->
      <div class="ip-field">
        <div class="ip-field__head">
          <label class="ip-field__label" for="groundRent">Ground rent p.a.</label>
          <span class="ip-hint"><span class="ip-hint__dot"></span>{{ PropertyLondon == 1 ? 'London avg: £500' : 'UK avg: £350' }}</span>
        </div>
        <div class="ip-input">
          <span class="ip-input__prefix">£</span>
          <input
            type="text"
            id="groundRent"
            class="ip-input__field"
            autocomplete="off"
            placeholder="{{ PropertyLondon == 1 ? '500' : '350' }}"
            [(ngModel)]="groundRent"
            (keyup)="groundRent=validation.amountWithComma(groundRent)"
            (keypress)="validation.numberOnly($event)">
        </div>
      </div>

      <!-- Service Charges -->
      <div class="ip-field">
        <div class="ip-field__head">
          <label class="ip-field__label" for="serviceCharges">Service charges p.a.</label>
          <span class="ip-hint"><span class="ip-hint__dot"></span>{{ PropertyLondon == 1 ? 'London avg: £3,000' : 'UK avg: £1,000' }}</span>
        </div>
        <div class="ip-input">
          <span class="ip-input__prefix">£</span>
          <input
            type="text"
            id="serviceCharges"
            class="ip-input__field"
            autocomplete="off"
            placeholder="{{ PropertyLondon == 1 ? '3,000' : '1,000' }}"
            [(ngModel)]="serviceCharges"
            (keyup)="serviceCharges=validation.amountWithComma(serviceCharges)"
            (keypress)="validation.numberOnly($event)">
        </div>
      </div>

      <!-- Other Expenses -->
      <div class="ip-field">
        <label class="ip-field__label" for="miscelleneousExpense">Other expenses p.a.</label>
        <div class="ip-input">
          <span class="ip-input__prefix">£</span>
          <input
            type="text"
            id="miscelleneousExpense"
            class="ip-input__field"
            autocomplete="off"
            placeholder="e.g. 1,000"
            [(ngModel)]="miscelleneousExpense"
            (keyup)="miscelleneousExpense=validation.amountWithComma(miscelleneousExpense)"
            (keypress)="validation.numberOnly($event)">
        </div>
      </div>

    </div><!-- /ip-form-body -->

    <div class="ip-form-actions">
      <button class="ip-btn ip-btn--ghost" type="button" [routerLink]="['/cashflow/step3']">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
          <line x1="19" y1="12" x2="5" y2="12"></line><polyline points="12 19 5 12 12 5"></polyline>
        </svg>
        Back
      </button>
      <button class="ip-btn ip-btn--accent" type="button" (click)="next()">
        Calculate Returns
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
          <line x1="5" y1="12" x2="19" y2="12"></line><polyline points="12 5 19 12 12 19"></polyline>
        </svg>
      </button>
    </div>
  </div><!-- /formCol -->

  <!-- ── RAIL ── -->
  <div rail>
    <div class="ip-rail-summary">
      <div class="ip-rail-summary__head">
        <div class="ip-rail-summary__loc">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path><circle cx="12" cy="10" r="3"></circle>
          </svg>
          <span class="ip-rail-summary__loc-name">{{ calcData?.City || 'United Kingdom' }}</span>
        </div>
        <div class="ip-rail-summary__buyer-tag" [class.is-uk]="foreignbuyer!=='1'">
          {{ foreignbuyer === '1' ? 'Foreign Buyer' : 'UK Resident' }}
        </div>
      </div>

      <div class="ip-rail-summary__body">
        <!-- Property & Financing -->
        <div class="ip-rs-section">
          <div class="ip-rs-section__head">
            <span class="ip-rs-section__label">Property &amp; Financing</span>
          </div>
          <div class="ip-rs-row">
            <span class="ip-rs-row__key">Value · LTV</span>
            <span class="ip-rs-row__val">£{{ calcData?.PropertyValue | number }} · {{ calcData?.loanAmount || '100' }}%</span>
          </div>
          <div class="ip-rs-row" *ngIf="calcData?.optmortgage==='1'">
            <span class="ip-rs-row__key">Type · Tenure</span>
            <span class="ip-rs-row__val">{{ calcData?.mortgageType === '1' ? 'Int Only' : 'Repayment' }} · {{ calcData?.loanTenure }} yrs</span>
          </div>
          <div class="ip-rs-row" *ngIf="calcData?.optmortgage==='0'">
            <span class="ip-rs-row__key">Financing</span>
            <span class="ip-rs-row__val">All-cash</span>
          </div>
        </div>

        <!-- Rental Income -->
        <div class="ip-rs-section">
          <div class="ip-rs-section__head">
            <span class="ip-rs-section__label">Rental Income</span>
          </div>
          <div class="ip-rs-row">
            <span class="ip-rs-row__key">Period · Yield</span>
            <span class="ip-rs-row__val">{{ calcData?.investedTenure }} yrs · {{ calcData?.rentalYeild }}</span>
          </div>
          <div class="ip-rs-row" *ngIf="calcData?.rentalGrowthEscalation">
            <span class="ip-rs-row__key">Escalation</span>
            <span class="ip-rs-row__val">{{ calcData?.rentalGrowthEscalation }}</span>
          </div>
        </div>

        <!-- Costs (current step) -->
        <div class="ip-rs-section">
          <div class="ip-rs-section__head">
            <span class="ip-rs-section__label">Upfront Costs</span>
          </div>
          <div class="ip-rs-row">
            <span class="ip-rs-row__key">SDLT</span>
            <span class="ip-rs-row__val">£{{ stampDutyLandTax || '—' }}</span>
          </div>
          <div class="ip-rs-row" *ngIf="calcData?.optmortgage!='0' && loanOriginationFee">
            <span class="ip-rs-row__key">Origination fee</span>
            <span class="ip-rs-row__val">{{ loanOriginationFee }}</span>
          </div>
        </div>

        <div class="ip-rs-section">
          <div class="ip-rs-section__head">
            <span class="ip-rs-section__label">Annual Running</span>
          </div>
          <div class="ip-rs-row" *ngIf="letteingManagFee">
            <span class="ip-rs-row__key">Management</span>
            <span class="ip-rs-row__val">{{ letteingManagFee }} of rent</span>
          </div>
          <div class="ip-rs-row" *ngIf="groundRent">
            <span class="ip-rs-row__key">Ground rent</span>
            <span class="ip-rs-row__val">£{{ groundRent }}</span>
          </div>
          <div class="ip-rs-row" *ngIf="serviceCharges">
            <span class="ip-rs-row__key">Service charges</span>
            <span class="ip-rs-row__val">£{{ serviceCharges }}</span>
          </div>
          <div class="ip-rs-row" *ngIf="miscelleneousExpense">
            <span class="ip-rs-row__key">Other</span>
            <span class="ip-rs-row__val">£{{ miscelleneousExpense }}</span>
          </div>
        </div>
      </div>

      <div class="ip-rail-summary__outlay">
        <div class="ip-rail-summary__outlay-label">Ready to calculate</div>
        <div class="ip-rail-summary__outlay-value">Step 4 of 4</div>
        <div class="ip-rail-summary__outlay-meta">Review above, then hit Calculate Returns</div>
      </div>
    </div>
  </div><!-- /rail -->

</app-ip-shell>
